import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { GenericSmartList, SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
import { CustomerModel } from '@models/CustomerModel';



@Component({
    selector: 'app-smart-list-user-transaction',
    templateUrl: './smart-list-user-transaction.component.html',
    styleUrls: ['./smart-list-user-transaction.component.scss']
})
export class SmartListUserTransactionComponent extends GenericSmartList<SmartListTransactionItem> implements OnInit, OnChanges {

    @Input() givis: SmartListTransactionItem[] = [];
    @Input() user: CustomerModel;

    constructor() {
        super();
    }

    ngOnInit() {        
        this.source = this.givis;
    }

    ngOnChanges(changes: SimpleChanges): void {

        for (const propName in changes) {
            if (propName === 'givis') {
                const change = changes[propName];
                if (!change.isFirstChange() && (change.previousValue !== change.currentValue)) {

                    this.source = this.givis;
                }
            }
        }
    }

    getPageMonth(current: number) {

        return [
            'ENE', 'FEB', 'MAR', 'ABR',
            'MAY', 'JUN', 'JUL', 'AGO',
            'SEP', 'OCT', 'NOV', 'DIC',
        ][current - 1];
    }
}